import styled from 'styled-components';
import * as Parent from '../Base/style';

export const ModalWrapper = styled(Parent.ModalWrapper)`
${({ theme }) => `
.scheduleForm{
    overflow: auto;
    max-height: 600px;
    .itemWrapper{
      margin-bottom: 10px;
      display: -webkit-inline-box;
        width: 100%;
        .label {
          width: 18%;
        }
        .value {
          font-weight: 600;
        }
      }
    form {
      align-items: center;
    }
    .scheduleDateWrapper{
      width: 50%;
      .fieldWrapper{
        display: block !important;
      }
    }
    padding: 0 60px;
    .fullWidth{
      width:100%;
  }
  .radioWrapper{
      width:100%;
      margin-bottom: 10px !important;
      .label{
          align-items: center;
          display: flex;
          flex: 0 0 18% !important;
          color: ${theme.colors.PRIMARY_CONTRAST};
      }
      .recurrenceIntervalBox {
          display: block !important;
      }
      .infoText{
          color: ${theme.colors.SECONDARY_MAIN};
      }
  }
  .recurrenceIntervalBoxLabel{
      padding-bottom: 25px;;
  }
  }
.MuiPopover-root {
    .MuiMenu-paper .MuiButtonBase-root{
        padding: 0;
    }
}
.fieldSection{
    justify-content: space-between;
     .MuiBox-root{
    flex: 0 0 70%;
     }
}
.subheaderSection {
    padding-left: 0 !important;
    text-transform: capitalize
    color: #000000 !important;
}
.deletePopupBtn {
    button {
        font-family: ${theme.palette.titleFont};
        font-size: 23px;
        height: 22px;
        font: normal 12px "Helvetica Neue", Helvetica, Arial, sans-serif;
        border: none;
        padding: 5px 15px !important;
        border-radius: 4px;
        text-transform: capitalize;
        &:hover {
            background: #2d3942 !important;
        }
    }
}
.imageSection img {
    width: 58px;
}
.deleteParent {
    text-align: center;
}
.successpopup h2 {
    font-size: 20px;
    margin-top: 0;
}
`}
`;
export const ModalWrapper2 = styled(Parent.ModalWrapper2)`
${({ theme }) => `
.MuiPopover-root {
    .MuiMenu-paper .MuiButtonBase-root{
        padding: 0;
    }
}
.fieldSection{
    justify-content: space-between;
     .MuiBox-root{
    flex: 0 0 70%;
     }
}
.MuiTypography-h1{
    padding-left: 0 !important;
    color: #000000 !important;
    text-transform: capitalize !important;
}
.subheaderSection {
    padding-left: 0 !important;
    text-transform: capitalize
    color: #000000 !important;
}
.imageSection img {
    width: 58px;
}
.deletedRow {
    color: ${theme.colors.MODAL_HEADING};
    padding-bottom: 20px;
}
.carousel-root .carousel.carousel-slider {
    .control-arrow {
        height: 34px !important;
    }
    .control-arrow:before{
        top: 0px;
        left: -10px;
        position: relative;
    }
    .control-next.control-arrow:before{
        left: -6px;
    }
}
.deletePopupBtn {
}
.coDriverReassignModal {
    align-items: stretch;
    min-width: 480px;
    padding: 0 12px 8px;
    text-align: left;
}
.coDriverReassignModal .reassignModalHeader {
    margin-bottom: 20px;
}
.coDriverReassignModal h2 {
    color: #000;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
    text-align: left;
    text-transform: none;
    width: auto;
}
.coDriverReassignModal .reassignSection {
    margin-bottom: 24px;
}
.coDriverReassignModal .reassignSectionForm {
    margin-bottom: 8px;
}
.coDriverReassignModal .reassignSectionTitle {
    color: #000;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: normal;
    margin: 0 0 14px;
    text-transform: none;
}
.coDriverReassignModal .reassignEventCard {
    padding: 0;
}
.coDriverReassignModal .reassignEventCardHeader {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    margin-bottom: 14px;
}
.coDriverReassignModal .reassignEventStatus,
.coDriverReassignModal .reassignEventTime {
    color: ${theme.colors.PRIMARY_CONTRAST};
    font-size: 14px;
    font-weight: 600;
}
.coDriverReassignModal .reassignEventGrid {
    display: grid;
    gap: 14px 32px;
    grid-template-columns: 1fr 1fr;
}
.coDriverReassignModal .reassignEventField {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.coDriverReassignModal .reassignEventFieldFull {
    grid-column: 1 / -1;
}
.coDriverReassignModal .reassignEventLabel {
    color: ${theme.colors.PRIMARY_CONTRAST};
    font-size: 15px;
    font-weight: normal;
    opacity: 0.87;
}
.coDriverReassignModal .reassignEventValue {
    color: ${theme.colors.PRIMARY_CONTRAST};
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
}
.coDriverReassignModal .reassignField {
    margin-bottom: 16px;
}
.coDriverReassignModal .reassignField:last-child {
    margin-bottom: 0;
}
.coDriverReassignModal .reassignField .MuiFormLabel-root {
    color: ${theme.colors.PRIMARY_CONTRAST};
    font-size: 15px;
    margin-bottom: 6px;
}
.coDriverReassignModal .reassignModalActions {
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 0;
}
.successpopup h2 {
    font-size: 20px;
}
`}
`;
export const ParentWrapper = styled(Parent.ParentWrapper)`
.MuiPopover-root {
    .MuiMenu-paper .MuiButtonBase-root{
        padding: 0;
    }
}
`;
